import { BulkDeleteButton } from 'react-admin'

const DraftBulkActionButtons = () => {

  return (
    <>
      <BulkDeleteButton />
    </>
  )
}

export default DraftBulkActionButtons